query PurchaseOrderSearchFilterTotals(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $searchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $isSearchAllData: Boolean
  $filterCreatedById: UUID
  $filterSupplierId: UUID
  $filterBusinessUnitId: UUID
  $filterCurrencyId: Int
  $filterDepartmentId: UUID
  $filterMultiStatusTypes: [Int]
  $filterPurchaseOrderTypeId: Int
  $filterProcessHistoryId: [UUID]
  $isFilterUnprocessedDocuments: Boolean
) {
  purchaseOrderSearchFilterTotals(
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSearchAllData: $isSearchAllData
    isSigningSearch: $isSigningSearch
    searchRequest: $searchRequest
    filterCreatedById: $filterCreatedById
    filterSupplierId: $filterSupplierId
    filterDepartmentId: $filterDepartmentId
    filterBusinessUnitId: $filterBusinessUnitId
    filterCurrencyId: $filterCurrencyId
    filterMultiStatusTypes: $filterMultiStatusTypes
    filterPurchaseOrderTypeId: $filterPurchaseOrderTypeId
    filterProcessHistoryId: $filterProcessHistoryId
    isFilterUnprocessedDocuments: $isFilterUnprocessedDocuments
  ) {
    totalAmount1
    totalAmount2
    totalAmount3
    totalCount1
  }
}